// dependencies
import { endOfDay, format } from "date-fns";
import React from "react";

// components
import Text from "../../../../../../components/Text";
import { CardHeader } from "../../../../components/Card";
import BreakdownChart from "./BreakdownChart";

// store
import useStore from "../../../../store";

// hooks
import { useNPSAdditionalFeedback } from "../../../../../../api/hooks";

// utils
import downloadCSV from "../../../../../../utils/downloadCSV";
import escapeCsvField from "../../../../../../utils/escapeCsvField";
import { getTimePeriodLabel } from "../../../../utils/getTimePeriodLabel";

const EnpsBreakdownChart = () => {
	const [filter] = useStore((state) => [state.filter]);

	const { data: npsAdditionalFeedbackData } = useNPSAdditionalFeedback({
		startDate: filter.startDate,
		endDate: filter.endDate || endOfDay(new Date()),
		requireFeedback: false,
	});

	const enpsResponses = npsAdditionalFeedbackData?.data;

	const getCSVContent = () => {
		if (!enpsResponses?.length) return "";
		const csvColumns = ["eNPS Score", "Additional Feedback", "Response Date"];

		const csvRows = enpsResponses.map((feedback) => [
			feedback.enps_value,
			escapeCsvField(feedback.additional_feedback || ""),
			format(new Date(feedback.submitted_at), "dd-MMM-yyyy"),
		]);

		return [csvColumns, ...csvRows].join("\n");
	};

	const selectCSVDownloadName = () => {
		const date = new Date().toDateString();
		return `PerformYard-Engagement-eNPS-Breakdown-${getTimePeriodLabel(filter)}-${date}.csv`;
	};

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							eNPS Breakdown
						</Text>
					</span>
				}
				info="This chart displays the eNPS Breakdown."
				options={
					enpsResponses && enpsResponses.length > 0
						? [
								{
									id: "download-csv",
									label: "Download CSV",
									action: () => {
										const csvContent = getCSVContent();
										const filename = selectCSVDownloadName();
										return downloadCSV(csvContent, filename);
									},
								},
							]
						: undefined
				}
			/>
			<BreakdownChart />
		</>
	);
};

export default EnpsBreakdownChart;
